import "./Home.module.css";
import Cabecalho from "@/reusable_sections/Header";
import ControlTotalEnVia from "./sections/ControlTotalEnVia";
import TrajectoryAndCommitment from "./sections/TrajectoryAndCommitment";
import NuestrosPilares from "./sections/NuestrosPilares";
import InfraestructuraYFlota from "./sections/InfraestructuraYFlota";
import SectoresDeEspecialidad from "./sections/SectoresDeEspecialidad";
import WaterArmoredProjects from "./sections/WaterArmoredProjects";
import RiskManagementCenter from "./sections/RiskManagementCenter";
import CaseStudy from "./sections/CaseStudy";
import TerminalDeSalida from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Cabecalho />
      <ControlTotalEnVia />
      <TrajectoryAndCommitment />
      <NuestrosPilares />
      <InfraestructuraYFlota />
      <SectoresDeEspecialidad />
      <WaterArmoredProjects />
      <CaseStudy />
      <RiskManagementCenter />
      <TerminalDeSalida />
<a href="https://wa.me/584146840865" target="_blank" rel="noopener noreferrer" className="floating-whatsapp">
  <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" style={{
        width: "30px",
        height: "30px"
      }} />
</a>
      
    </div>;
}